module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/aneck7-c81eb79d79fbcf03df861f4e9f835e87.jpg";